import { Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { BetslipV2OptionMarketPick } from '../../../core/picks/betslip-v2-option-market-pick';
import { BetslipV2ParticipantPick } from '../../../core/picks/betslip-v2-participant-pick';
import { OverAskMarketTypeChange } from '../../../model/over-ask/over-ask';
import { SingleSlipType } from '../../bet-generation/slip-type';
import { IBetslipOverAskPickComponentProps } from '../models/over-ask.model';

@Component({
    template: '',
    standalone: false,
})
export class BetslipOverAskPickBaseComponent {
    @Input() props: IBetslipOverAskPickComponentProps;

    constructor(private siteCore: Sitecore) {}

    getInitialMarket(useAbbr: boolean = true): string {
        const pick = this.props.overAskPick.pick;
        if (BetslipV2OptionMarketPick.isPick(pick) || BetslipV2ParticipantPick.isPick(pick)) {
            return this.props.overAskPick.isEachWay
                ? useAbbr
                    ? this.siteCore.betslip.messages.EachWayAbbr
                    : this.siteCore.betslip.messages.EachWay
                : useAbbr
                  ? this.siteCore.horseRacing.markets.WinShort
                  : this.props.overAskPick.pick.marketName.name;
        }

        return pick.marketName.name;
    }

    getCounterOfferMarket(useAbbr: boolean = true): string {
        switch (this.props.overAskPick.changes.marketType) {
            case OverAskMarketTypeChange.Win:
                return useAbbr ? this.siteCore.horseRacing.markets.WinShort : this.props.overAskPick.pick.marketName.name;
            case OverAskMarketTypeChange.EachWay:
                return useAbbr ? this.siteCore.betslip.messages.EachWayAbbr : this.siteCore.betslip.messages.EachWay;
            default:
                return '';
        }
    }

    get shouldShowBadge(): boolean {
        return !!this.props.overAskPick.changes.marketType && this.props.overAskBet.type instanceof SingleSlipType;
    }
}
